Postlogin = (function (postlogin) {
    postlogin.GroupsEdit = {};
    const self = postlogin.GroupsEdit;

    self.init = function () {
        // Ported from bootstrap-select's .selectpicker() on 2026-05-11
        // as prep for the Bootstrap 5 upgrade. Same single-call
        // Tom Select shape we used on /users/ — multi-select with
        // remove chips, placeholder, diacritic-insensitive search.
        const filterLicense = document.getElementById('filter-license');
        if (filterLicense) {
            // eslint-disable-next-line no-new
            new TomSelect(filterLicense, {
                placeholder: 'All licenses selected',
                plugins: ['remove_button'],
                diacritics: true,
                maxOptions: null,
            });
        }
    };

    return postlogin;
}(Postlogin || {}));
